import { useMutation } from '@tanstack/react-query';
import { updatePosition } from './api.routes';
import queryClient from '../../../../../utilities/queryClient';
// Debugging - This can be used to simulate an api failure
// import { simulateApiFail } from '../../../../../utilities/helpers/debug/api.debuggers';

// FormData should be in this shape -> PositionUpdatePostData
export function useUpdatePositionData(positionId: string) {
  return useMutation({
    mutationKey: ['position-update', positionId],
    mutationFn: (data: any) => updatePosition(data),

    onSuccess: (data, variables) => {
      const fundName = variables.fund_name;
      queryClient.invalidateQueries({
        queryKey: ['editable-positions-data', fundName],
      });
    },
  });
}
